import controller from './mf-match.controller';
import template from './mf-match.html';

export default {
	template,
	bindings: {
		match:    '<',
		order:    '<',
		select:   '&',
		create:   '&',
		query:    '<',
		openForm: '<',
		values:   '<',
		activeItem: '<',
	},
	controller,
	require:  {
		mf:            '^^?mf',
		popup:         '^^mfPopup',
		postalAddress: '^^?postalAddress',
		smartField:    '^^?smartField',
	},
};
